import React from 'react'

import { Gallery, Title } from '@cms/ui'
import Head from '../../head'

const Page = (props) => {
  if (!props.data) return null
  const { works, year } = props.data
  // Get information about the current URL.
  const desc = `Chan Kwan-Lok's ${year} creations.`

  const defaultWorkThumbnailPath = works?.[0]?.thumbnail?.hash;
  const defaultWorkThumbnail = defaultWorkThumbnailPath ? `${process.env.NEXT_IMAGE_ENDPOINT}/${defaultWorkThumbnailPath}` : undefined

  return (
    <>
      <Head
        title={`Works in ${year}`}
        desc={desc}
        ogTitle={`Works in ${year} | CHAN KWAN LOK | 陳鈞樂`}
        img={defaultWorkThumbnail}
      />
      <Title>{`Works in ${year}`}</Title>
      <Gallery items={works} />
    </>
  )
}

export default Page

export async function getStaticProps({ params, preview = false }) {
  const { parseData, fetchYear } = await import('../../data')

  const data = parseData(await fetchYear(params.slug), 'years')

  const works = [
    ...data.works.filter(({ series }) =>
      series ? !data.series.map(({ id }) => id).includes(series.id) : true
    ),
    ...data.series,
  ]

  delete data.series

  return {
    props: {
      preview,
      data: {
        ...data,
        works,
      },
    },
  }
}

export async function getStaticPaths() {
  const { fetchYears } = await import('../../data')

  const slugs = await fetchYears()

  return {
    paths: slugs.map(({ id, year }) => ({
      params: {
        // id,
        slug: String(id),
      },
    })),
    fallback: false,
  }
}
